/* eslint-disable react/no-multi-comp */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
import React from 'react';
import { Page, Document, StyleSheet } from '@react-pdf/renderer';
import { Header } from './components';
import { ContentJV} from './components';
import { ContentRO} from './components';
import { ContentROJ} from './components';
import { ContentRE} from './components';
import { ContentUG} from './components';
import { ContentPI} from './components';
import { ContentJO} from './components';
import { Footer } from './components';

// Create styles
const styles = StyleSheet.create({
  page: {
    display:'flex',
    flexDirection: 'column',
    justifyContent:'flex-start'
  },
  section: {
    margin: 5,
    padding: 5,
   
  }
});
const ClientOffer = (props) => {
  const {currentProduct, currentOrder, curs}=props
  
  const product = () => {
    switch(currentProduct.cod) {
      case 'jv':   
        return <ContentJV currentOrder={currentOrder} />;
      case 'ro':  
        switch(currentProduct.subTip) {
          case 'ROJ':
            return <ContentROJ currentOrder={currentOrder} />;
          default:
            return <ContentRO currentOrder={currentOrder} />;
        }
      case 're':   
        return <ContentRE
          currentOrder={currentOrder}
          curs={curs}
        />;
      case 'ug':   
        return <ContentUG
          currentOrder={currentOrder}
          curs={curs}
        />;
      case 'pi':  
        return <ContentPI
          currentOrder={currentOrder}
          curs={curs}
        />;
      case 'jo':  
        return <ContentJO currentOrder={currentOrder} />;
      case 'sv':  
        return null;
      case 'ex':
        return null;
      default: 
        return null;
    }
  }
 
  return(
    <Document>
      <Page
        // orientation={props.currentProduct.cod==='jv'? 'portrait':'landscape'}
        orientation={'landscape'}
        size="A4"
        style={styles.page}
      >
        <Header
          currentOrder={props.currentOrder}
          currentProduct={props.currentProduct}
          currentUser={props.currentUser}
        />
        {product()}
        
        <Footer
          currentOrder={props.currentOrder}
          currentProduct={props.currentProduct}
        />
      </Page>
    </Document>
  )  
};


export default ClientOffer
